<template>
    <header>
        <img
            src="https://static.web.sdo.com/cqyh/pic/act/2025/0225_Baidu/logo.png"
        />
        <h1>实物奖励发货信息提交</h1>
        <div class="user-info" v-if="!user.login_account">
            您尚未登录，<span @click="loginEvent">登录</span>
        </div>
        <div class="user-info" v-else>
            欢迎您，<strong>{{ user.login_account }}</strong>
            <span @click="logoutEvent">注销</span>
        </div>
    </header>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useUser } from "../../store/store";

const { user } = storeToRefs(useUser());

const loginEvent = () => {
    return sdoLogin();
};
const logoutEvent = () => {
    return sdoLogout();
};
</script>

<style lang="scss" scoped>
header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #1e1c1a;
    height: 260px;
    font-family: STKaiti;
    color: #ffeace;
    font-size: 32px;
    position: relative;
    .user-info {
        position: absolute;
        display: flex;
        bottom: 16px;
        right: 60px;
        font-size: 16px;
        align-items: center;
        font-family: "Yahei";
        strong {
            font-weight: bold;
        }
        span {
            padding: 4px 16px;
            font-size: 14px;
            background: #ffeace;
            color: #010101;
            cursor: pointer;
            border-radius: 4px;
            margin-left: 12px;
            &:hover {
                background: #ffeeee;
            }
        }
    }
}
</style>
